export const cutOffOddCharacters = (string) => {
  return string.length > 175 ? string.slice(0, 175) + '...' : string;
};
